import { Link } from 'react-router-dom';

const footerNav = [
  { label: 'Fragancias', href: '/fragrances' },
  { label: 'Nosotros', href: '/about' },
  { label: 'Noticias', href: '/news' },
  { label: 'Contacto', href: '/contact' },
];

const legalNav = [
  { label: 'Política de Privacidad', href: '/privacy' },
  { label: 'Aviso Legal', href: '/legal' },
  { label: 'Política de Cookies', href: '/cookies' },
];

export default function Footer() {
  return (
    <footer className="bg-[#1a1a1a] text-white">
      <div className="px-6 md:px-10 lg:px-16 py-16 md:py-20">
        {/* Top Section */}
        <div className="flex flex-col lg:flex-row justify-between gap-12 lg:gap-16 mb-16">
          {/* Brand & Intro */}
          <div className="lg:w-1/3">
            <img
              src="https://storage.readdy-site.link/project_files/9df4a25d-3a45-400e-b6ef-a6922afe5ed4/b41d22fa-d180-46e1-9fb2-92fa040b6f94_222.png?v=28ae809954d7951413d6cac782f150b6"
              alt="Esencia&co."
              className="h-8 md:h-10 w-auto object-contain mb-6"
            />
            <p className="text-gray-400 text-sm leading-relaxed max-w-xs">
              Descubre insumos de perfumería fina seleccionados para impulsar tu negocio. Calidad, variedad y respaldo que perduran en cada producto
            </p>
          </div>

          {/* Navigation */}
          <div className="lg:w-1/4">
            <nav className="flex flex-col gap-3">
              {footerNav.map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  className="text-sm text-gray-400 hover:text-white transition-colors duration-300"
                >
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>

          {/* Contact Info */}
          <div className="lg:w-1/4">
            <div className="text-xs uppercase tracking-widest text-gray-500 mb-4">
              Oficina Central
            </div>
            <div className="text-sm text-gray-400 leading-relaxed mb-6">
              Bogotá Colombia<br />
              comercial@esenciayco.co<br />
              +57 311 2245754<br />
              Av. de las Américas # 62-11<br />
              Bogotá Colombia
            </div>

          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-800 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-gray-500">
            © {new Date().getFullYear()} Esencia&co. Todos los derechos reservados.
          </p>
          <nav className="flex items-center gap-6">
            {legalNav.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className="text-xs text-gray-500 hover:text-gray-300 transition-colors"
              >
                {link.label}
              </Link>
            ))}
          </nav>
        </div>
      </div>
    </footer>
  );
}